import AjaxResolver from 'owd/module/ajax';

export default class DefaultResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('.logo').each(function() {
			var html = $(this).html();
			$(this).html(html);
		});

		$('.header').transition({
			opacity: 1
		}, 500, 'ease-out');

		$('.ajax-wrapper > *').transition({
			opacity: 1
		}, 500, 'ease-out', () => {
			deferred.resolve();
		});


		if ( location.hash !== '' ) {
			const offset = $('.header').height();

			$('html, body').stop().animate({
				scrollTop: $(location.hash).offset().top - offset + 'px'
			}, 0);

			if ($('.submenu').length && window.matchMedia('(min-width: 1023px)').matches) {

				const offset = $('.header').height() + $('.submenu').height();

				$('html, body').stop().animate({
					scrollTop: $(location.hash).offset().top - 100 + 'px'
				}, 0);
			}
		}

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();


		$('.header').transition({
			opacity: 0
		}, 250, 'ease-out');

		$('.ajax-wrapper > *').transition({
			opacity: 0
		}, 250, 'ease-out', () => {
			this.app.dom.$window.scrollTop(0);
			deferred.resolve();
		});


		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const $old = $('.ajax-wrapper');
		const $oldHeader = $('.header');
		const bodyClass = $loadedContent.find('.overall').data('body-class');
		const bodyTheme = $loadedContent.find('.overall').data('theme');

		$loadedContent.find('.ajax-wrapper > *, .header').css({
			opacity: 0
		});

		if (this.preventUpdateBodyClass !== true) {
			$('body').attr('class', bodyClass);
			$('body').attr('data-theme', bodyTheme);
		}

		const $new = $loadedContent.find('.ajax-wrapper');
		const $newHeader = $loadedContent.find('.header');

		$old.after($new);
		$oldHeader.after($newHeader);
		$old.remove();
		$oldHeader.remove();

		deferred.resolve($old, $oldHeader, $new, $newHeader);

		return deferred.promise();
	}
}
